import React from "react";
import { RouteComponentProps, Redirect } from 'react-router';
import { Row, Col } from 'reactstrap';
import Navigation from '../../constants/enums/NavigationEnum'
import { Settings } from '../../constants/settings'
import { Loader } from "../components/Loader";

interface AuthCallbackState {
  isRedirect: boolean;
}


export default class AuthCallback extends React.PureComponent<RouteComponentProps, AuthCallbackState> {


  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      isRedirect: false
    }

    this.timeOutRedirectTask = null;
  }

  private timeOutRedirectTask: NodeJS.Timeout | null;

  componentDidMount(): void {
    this.timeOutRedirectTask = setTimeout(() => {
      this.setState({
        isRedirect: true
      })
    }, 15000);
  }
  render() {

    return (
      <React.Fragment>
        <div id="CallbackCantainer">
          {this.state.isRedirect &&
            <Redirect to={Navigation.GeneralPage} />

          }
        </div>
      </React.Fragment>


    );
  }
}